import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SummaryMaterialsTable extends Component {
  state = {
    collapse: true,
    locations: [],
  };

  componentDidMount() {
    this.extendLocations();
  }

  onChangeCollapse = () => {
    this.setState({ collapse: !this.state.collapse });
  }

  extendLocations() {
    const locations = [];
    for (const detail of this.props.pzgik.pzgik_claim_details) {
      // obliczenie liczby wszystkich egzemplarzy dla danego materialu
      let totalCount = 0;
      for (const loc of detail.locations) {
        totalCount += loc.liczbaEgzemplarzy;
      }
      for (const loc of detail.locations) {
        const extendedLocation = {
          ...loc,
          formaMat: detail.formaMat,
          wysokoscOplatyPoj: detail.wysokoscOplatyPoj,
          iloscDanych: detail.iloscDanych,
          totalCount,
        };
        locations.push(extendedLocation);
      }
    }
    this.setState({ locations });
  }

  renderLocation = (location, i, ifDataFormatNotPrinted, isPayable) => {
    let loc = null;
    if ((!this.state.collapse && i < 5) || this.state.collapse) {
      loc = (<tr style={{ color: '#777' }} key={`location_${i}`}>
        {this.props.requestSubject && this.props.requestSubject.includes('mapa glebowo-rolnicza w skali 1:5 000') ?
          <td>{location.nazwa}</td>
        :
          <td>{location.godlo}</td>
        }
        {!ifDataFormatNotPrinted && <td>{location.formaMat === "drukowana" && location.liczbaEgzemplarzy}</td>}
        <td>{location.formaMat}</td>
        {isPayable && <td>{location.koszt.toFixed(2)} zł</td>}
      </tr>);
    }
    return loc;
  }

  roundNumbers = (num, digits) => {
    const multiplier = Math.pow(10, digits || 0);
    return Math.round(num * multiplier) / multiplier;
  }

  render() {
    const shippingForm = this.props.pzgik.pzgik_claim_details[0].formaPrzekaz;
    const ifDataFormatNotPrinted = this.props.pzgik.pzgik_claim_details.every(({ formaMat }) => formaMat !== "drukowana");
    const ifCarrierFee = (shippingForm === "Odbiór osobisty" || shippingForm === "Wysyłka pod wskazany adres") && ifDataFormatNotPrinted;
    const carrierFee = this.props.pzgik.WysOplatyNosnik || 0.00;

    const feeAmount = parseFloat(this.roundNumbers(this.roundNumbers((this.props.pzgik.wysokoscOplaty), 2), 1).toFixed(2)) || 0.00;

    const deliveryAmount = this.props.pzgik.wysOplatyPrzesylka || 0.00;
    const status = this.props.pzgik.status;
    const ifDeliveryFee = (status === 'do opłacenia' || status === 'opłacono, przygotowano' || status === 'opłacono, do przygotowania') && (shippingForm === "Wysyłka pod wskazany adres" || shippingForm === "Wysyłka pod wskazany adres - własny nośnik");

    const isPayable = this.props.isPayable;
    const cost = carrierFee + feeAmount + deliveryAmount;

    const sum_cost = this.roundNumbers(this.roundNumbers((cost), 2), 1).toFixed(2);

    return (
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Wybrane obszary</th>
            {!ifDataFormatNotPrinted && <th>Liczba egzemplarzy</th>}
            <th>Format danych</th>
            {isPayable && <th>Opłata za materiał</th>}
          </tr>
        </thead>
        <tbody>
          {this.state.locations.map((location, idx) => {
            return this.renderLocation(location, idx, ifDataFormatNotPrinted, isPayable);
          })}
          {this.state.locations.length > 5 ?
            <tr key={'collapseButton'}>
              <td />
              <td />
              <td>
                <div onClick={() => this.onChangeCollapse()} style={{ textAlign: 'right' }}>
                  <span>{!this.state.collapse ? 'Rozwiń' : 'Zwiń'}</span>
                  <span className={`fa fa-chevron-${!this.state.collapse ? 'down' : 'up'}`} aria-hidden="true" />
                </div>
              </td>
            </tr> : null
          }
          {/* {isPayable && ifDeliveryFee && <tr style={(!ifCarrierFee || this.props.userDevice) ? { color: '#777', borderTop: 'solid 2px black' } : {}}>
            <td style={{ fontWeight: 'bold', color: 'black'}}>Suma:</td>
            <td colSpan={4} style={{textAlign: 'right'}}>{feeAmount.toFixed(2)} zł {(shippingForm === "Wysyłka pod wskazany adres" || shippingForm === "Wysyłka pod wskazany adres - własny nośnik") && ("(bez kosztów wysyłki pocztowej)")}</td>
          </tr>}
          {isPayable && !ifDeliveryFee && <tr style={(!ifCarrierFee || this.props.userDevice) ? { color: '#777', borderTop: 'solid 2px black' } : {}}>
            <td style={{ fontWeight: 'bold', color: 'black'}}>Suma:</td>
            <td colSpan={4} style={{textAlign: 'right'}}>{feeAmount.toFixed(2)} zł {(shippingForm === "Wysyłka pod wskazany adres" || shippingForm === "Wysyłka pod wskazany adres - własny nośnik") && ("(bez kosztów wysyłki pocztowej)")}</td>
          </tr>} */}
          {isPayable && <tr style={(!ifCarrierFee || this.props.userDevice) ? { color: '#777', borderTop: 'solid 2px black' } : {}}>
            <td style={{ fontWeight: 'bold', color: 'black'}}>Suma:</td>
            <td colSpan={4} style={{textAlign: 'right'}}>{feeAmount} zł {(shippingForm === "Wysyłka pod wskazany adres" || shippingForm === "Wysyłka pod wskazany adres - własny nośnik") && ("(bez kosztów wysyłki pocztowej)")}</td>
          </tr>}
          {ifCarrierFee && !this.props.userDevice && (
            <tr style={{ color: '#777', borderTop: 'solid 2px black' }}>
              <td style={{ fontWeight: 'bold', color: 'black'}}>Opłata za nośnik:</td>
              <td colSpan={4} style={{textAlign: 'right'}}>{carrierFee && carrierFee.toFixed(2)} zł</td>
            </tr>
          )}
          {ifDeliveryFee && (
            <tr style={{ color: '#777', borderTop: 'solid 2px black' }}>
              <td style={{ fontWeight: 'bold', color: 'black'}}>Koszt wysyłki pocztowej:</td>
              <td colSpan={4} style={{textAlign: 'right'}}>{deliveryAmount && deliveryAmount.toFixed(2)} zł</td>
            </tr>
          )}
          {this.props.shortName !== 'UdostepnienieMaterialowPublicznych' ?
            <tr style={{ borderTop: 'solid 2px black' }}>
              <td style={{ fontWeight: 'bold' }}>Łącznie:</td>
              <td colSpan={4} style={{textAlign: 'right'}}><b>{sum_cost} zł</b></td>
            </tr> : null}
        </tbody>
      </table>
    )
  }
}

SummaryMaterialsTable.propTypes = {
  pzgik: PropTypes.object.isRequired
};

export default SummaryMaterialsTable;


// WEBPACK FOOTER //
// src/components/SummaryMaterialsTable/SummaryMaterialsTable.js